import { useMediaQuery } from "@mui/material"

/**
 * Phones and tablets: touch layouts (DailyJob card list + full-screen job dialog, slim app bar in MainLayout).
 * Large touch tablets (iPad Pro 12.9" landscape = 1366px) count as compact too, desktop mouse screens don't.
 * noSsr: answer on the first render so the DataGrid is not mounted and then thrown away.
 */
const COMPACT_QUERY = "(max-width:1199.95px), (pointer: coarse) and (max-width:1400px)"
const PHONE_QUERY = "(max-width:599.95px)"

const useCompactLayout = () => useMediaQuery(COMPACT_QUERY, { noSsr: true })

export const usePhoneLayout = () => useMediaQuery(PHONE_QUERY, { noSsr: true })

export default useCompactLayout
